(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tables.addtowaitlist', {
            parent: 'tables',
            url: '/create/waitlist',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/tables/create/waitlist/waitlist.html',
                    controller: 'CreateWaitlistController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('tables.event');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
